"use strict";
exports.__esModule = true;
exports.EXPENSE_ACCOUNTS = void 0;
var EXPENSE_ACCOUNTS = {
    RENT: 'rent',
    FOOD: 'food',
    UTILITIES: 'utilities',
    INSURANCE: 'insurance',
    TELECOMMUNICATION: 'telecommunication',
    PROPERTY_MAINTENANCE: 'propertyMaintenance',
    HEALTH: 'health',
    CLOTHING: 'clothing',
    ENTERTAINMENT: 'entertainment',
    TRANSPORTATION: 'transportation',
    CHILD_CARE: 'childcare',
    CHILD_EDUCATION: 'childEducation',
    SELF_EDUCATION: 'selfEducation',
    RETAIL: 'retail',
    DIGITAL_SUBSCRIPTIONS: 'digitalSubscriptions',
    GROCERIES: 'groceries',
    GAMBLING: 'gambling',
    FITNESS: 'fitness',
    TRAVEL: 'travel',
    PET_CARE: 'petCare',
    OTHER: 'other'
};
exports.EXPENSE_ACCOUNTS = EXPENSE_ACCOUNTS;
